export default __webpack_public_path__ + "static/partners-1f050b94b664a444472c5602dbe17088.png";